import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAPI from './api/index'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.config.productionTip = false
Vue.use(VueAPI)
Vue.use(ViewUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
